<template>
  <router-view/>
</template>

<script>
import '@/assets/style.scss';

export default {
  name: 'App',
  components: {},
  data: () => ({
  }),
};
</script>
